// Mini-formulario del hero (modules/hero-world): puente al formulario final.
// No envía nada: copia el correo al campo email de #ligo-contact-form, baja hasta
// #contacto y enfoca el primer campo vacío. Si el formulario no está en la
// página, sigue el href nativo (action="#contacto").

document.addEventListener('DOMContentLoaded', function () {
  const mini = document.querySelector('[data-hero-mini]')
  if (!mini) return

  mini.addEventListener('submit', function (e) {
    const form = document.getElementById('ligo-contact-form')
    if (!form) return
    e.preventDefault()

    const email = mini.querySelector('input[type="email"]')
    const target = form.querySelector('[name="email"]')
    if (email && target && email.value.trim()) target.value = email.value.trim()

    const section = document.getElementById('contacto') || form
    section.scrollIntoView({ behavior: 'smooth', block: 'start' })

    const next = Array.from(form.querySelectorAll('input, textarea')).find(function (el) {
      return !el.value
    })
    if (next) setTimeout(function () { next.focus({ preventScroll: true }) }, 600)
  })
})
